import { Component, OnInit, OnChanges, Input, ViewChild, OnDestroy } from '@angular/core';
import { ProfileService } from '../../shared/profile.service';
import { ReferralReportSummary } from './referral-report-summary.model';
import { ChartService } from '../../../shared/chart/chart.service';
import { ChartData } from '../../../shared/chart/chart-data.model';
import { UIChart } from 'primeng/chart';
import { NavigationService } from 'src/app/shared/navigation/navigation.service';
import { ObservationService } from 'src/app/shared/observation/observation.service';
import { Subscription } from 'rxjs';
import { AddReferralDialogComponent } from './add-referral-dialog/add-referral-dialog.component';

@Component({
  selector: 'wl-profile-view-referral-report',
  templateUrl: './referral-report.component.html',
  styleUrls: ['./referral-report.component.css'],
  providers: [ChartService],
    standalone: false
})
export class ProfileViewReferralReportComponent implements OnInit, OnChanges, OnDestroy {
  @Input() public profileId: number;
  @ViewChild('referralChart', { static: false }) public referralChart: UIChart;
  @ViewChild(AddReferralDialogComponent) private _addReferralDialogComponent: AddReferralDialogComponent;

  private _profileService: ProfileService;
  private _chartService: ChartService;
  private _navigationService: NavigationService;
  private _observationService: ObservationService;
  private _profileSubscription: Subscription;

  public referralSummary: ReferralReportSummary;
  public totalReferrals: number;
  public chartData: ChartData;
  public chartOptions: any;
  public colors: Array<string>;

  public constructor(
    profileService: ProfileService,
    chartService: ChartService,
    navigationService: NavigationService,
    observationService: ObservationService
  ) {
    this._profileService = profileService;
    this._chartService = chartService;
    this._navigationService = navigationService;
    this._observationService = observationService;

    this.chartData = new ChartData();
    this.chartOptions = {
      responsive: false,
      plugins: {
        legend: {
          position: false,
        },
      },
    };

    this.referralSummary = {} as ReferralReportSummary;
  }

  ngOnInit() {
    this._profileSubscription = this._observationService.observeProfiles().subscribe((id) => {
      this.profileUpdated(id);
    });
  }

  ngOnChanges() {
    this.loadData();
  }

  ngOnDestroy() {
    if (this._profileSubscription) {
      this._profileSubscription.unsubscribe();
    }
  }

  private profileUpdated(id: number) {
    if (id === this.profileId) {
      this.loadData(true);
    }
  }

  public navigateToReferralReport() {
    this._navigationService.navigateToLegacyReferralReportPage(this.profileId);
  }

  public openAddReferralDialog() {
    this._addReferralDialogComponent.open();
  }

  public loadData(forceRefresh?: boolean) {
    this.chartData = new ChartData();
    this.chartOptions = {
      responsive: false,
      plugins: {
        legend: {
          position: false,
        },
      },
    };

    this._profileService.getProfileViewReferralReport(this.profileId, forceRefresh).then((data: ReferralReportSummary) => {
      this.referralSummary = data;
      this.totalReferrals = data.Total;

      for (const row of data.ReferralCollection) {
        this.chartData.labels.push(row.ReferralType);
        this.chartData.datasets[0].data.push(row.ReferralCount);
      }

      this.colors = this._chartService.getChartColors(data.ReferralCollection.length);
      this.chartData.datasets[0].backgroundColor = this.colors;

      this.referralChart.refresh();
    });
  }
}
